/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

const StyledTableCell = styled(TableCell)(() => ({
  border: 0,
  [`&.${tableCellClasses.head}`]: {
    color: '#BDBEC1',
    backgroundColor:'#2E3036',
    fontSize: 12,
    fontFamily: 'Inter',
    fontWeight: 500
  },
  [`&.${tableCellClasses.body}`]: {
    color: '#EFF1F6',
    fontSize: 14,
    fontFamily: 'Inter',
    fontWeight: 400
  },
}));

const BlankTableCell = styled(TableCell)(() => ({
  color: '#BDBEC1',
  border: 0,
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    backgroundColor:'#2E3036',
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  backgroundColor: '#202227',
  borderBottom: '1px solid #2E3036',
}));

interface ITableProps {
  stripeCus?: any;
  handleTabChange?: any;
}


const MeterTablePlaceholder: React.FC<ITableProps> = (props: ITableProps) => {
  const { stripeCus, handleTabChange } = props;


  return (
    <TableContainer component={Paper} className='api-table-paper'>
      <div className='overage-fees-table-header'>
        <div className='overage-fees-table-header-content'>
          <div className='overage-fees-table-header-text-group'>
            <div className='overage-fees-table-header-text-frame'>
              <div className='overage-fees-table-header-title'>
                External API Meters
              </div>
              {/* <div
                className='overage-fees-table-toggle'
              >
                <div className='overage-fees-table-toggle-text'>
                  Manage Plans
                </div>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                  <path d='M5.83334 14.1663L14.1667 5.83301M14.1667 5.83301H5.83334M14.1667 5.83301V14.1663' stroke='#CECFD2' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <Table sx={{ minWidth: 650 }} aria-label='simple table'>
        <TableHead className='api-table-head'>
          <TableRow>
            <StyledTableCell>API Endpoint</StyledTableCell>
            <StyledTableCell>Next Payment</StyledTableCell>
            <StyledTableCell>Monthly Calls</StyledTableCell>
            <StyledTableCell>Monthly Amount</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>

          <StyledTableRow
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <StyledTableCell component='th' scope='row'>
        People / Companies
            </StyledTableCell>
            <StyledTableCell component='th' scope='row'>
        -
            </StyledTableCell>
            <StyledTableCell component='th' scope='row'>
              -
            </StyledTableCell>
            <StyledTableCell component='th' scope='row'>
            + Add to Plan
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <StyledTableCell component='th' scope='row'>
        Products
            </StyledTableCell>
            <StyledTableCell component='th' scope='row'>
        -
            </StyledTableCell>
            <StyledTableCell component='th' scope='row'>
              -
            </StyledTableCell>
            <StyledTableCell component='th' scope='row'>
            + Add to Plan
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <StyledTableCell component='th' scope='row'>
       Automation
            </StyledTableCell>
            <StyledTableCell component='th' scope='row'>
        -
            </StyledTableCell>
            <StyledTableCell component='th' scope='row'>
              -
            </StyledTableCell>
            <StyledTableCell component='th' scope='row'>
            + Add to Plan
            </StyledTableCell>
          </StyledTableRow>
        </TableBody>
      </Table>

    </TableContainer>
  );
};

export default MeterTablePlaceholder;
